// extracted by mini-css-extract-plugin
export default {"gridContainer":"_ldbzdk","slimGrid":"_dsgeti"};